import { render } from "./SchedaProgetto.vue?vue&type=template&id=639f7dce"
import script from "./SchedaProgetto.vue?vue&type=script&lang=js"
export * from "./SchedaProgetto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__